import React from 'react';
import { Box } from '../ui';

export function SuggestionStatusToastContent(props: {
  text: string;
  onStop: () => void;
}) {
  return (
    <Box>
      <Box>{props.text}</Box>
      <Box mt={4} color="white">
        <a
          href="#"
          style={{ color: 'white' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onStop();
          }}
          data-testid="stop-suggestion-calculation"
        >
          Stop calculation
        </a>
      </Box>
    </Box>
  );
}
